module.exports = __webpack_public_path__ + "static/media/wlcm-img.065776cb.png";